import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="remove"
// Simple controller to remove an element from the DOM
export default class extends Controller {
  remove(event) {
    event.preventDefault();
    this.element.remove();
  }
}
